export default __webpack_public_path__ + "static/media/dog-selected.25a81a79.svg";